import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import { InputField, Select } from 'Common/SemanticWrapper';
import { HACCP_FORM_NAME } from 'Common/FormEnum';
import {
  ControlInfoHACCPFormEnum as Fields,
  HACCPFieldEnum,
} from 'Common/FieldEnum';
import {
  ReactTableWrapperColumnProperties,
  ReactTableWrapperCogColumnProperties,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { createToast, toastType } from 'Common/ToastHelper';

import * as Selectors from '../state/haccp/selectors';
import * as HACCPActions from '../state/haccp/actions';

class HACCPTable extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };
  menuOptions = [
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: row => {
        const { dispatch, fields } = this.props;

        dispatch(
          setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.REMOVE_HACCP,
            functionsToRunOnOk: [
              () => {
                const path = _.toPath(row);
                const index = Number(path[1]);

                const field = fields.get(index);

                if (field && field.Id) {
                  const updatedFields = fields
                    .getAll()
                    .filter((x, i) => index !== i);

                  dispatch(HACCPActions.deleteHACCP(updatedFields));
                } else {
                  fields.remove(index);
                  createToast(
                    toastType.success,
                    'Success',
                    'Deleted HACCP',
                    true
                  );
                }
              },
            ],
          })
        );
      },
      disabledWhen: row => {
        return this.props.isReadOnly;
      },
    },
  ];
  render() {
    const { fields, HACCPTypeOptions } = this.props;
    return (
      <React.Fragment>
        <ReactTable
          data={fields}
          pageSize={fields.length}
          showPageSizeOptions={false}
          showPagination={false}
          columns={[
            {
              id: 'HACCPTypeId',
              Header: 'HACCP Type',
              Cell: row => {
                return (
                  <Field
                    name={`${row.original}.HACCPTypeId`}
                    maxLength={100}
                    component={Select}
                    fluid={true}
                    options={HACCPTypeOptions}
                    usePortal={true}
                  />
                );
              },
              ...ReactTableWrapperColumnProperties,
              width: 200,
              sortable: false,
              filterable: false,
            },
            {
              id: 'Description',
              Header: 'Description',
              Cell: row => {
                return (
                  <Field
                    name={`${row.original}.Description`}
                    maxLength={100}
                    component={InputField}
                    fluid={true}
                    hideEmptyError={true}
                    showOnlyTouchedError={true}
                    keyboardShortcuts={{
                      'mod+d': '°',
                    }}
                  />
                );
              },
              ...ReactTableWrapperColumnProperties,
              sortable: false,
              filterable: false,
            },
            {
              ...ReactTableWrapperCogColumnProperties,
              Cell: gridProps => {
                return GridContextMenu({
                  gridProps,
                  options: this.menuOptions,
                });
              },
            },
          ]}
        />
        <Button onClick={() => fields.push({})}>Add HACCP</Button>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  HACCPTypeOptions: Selectors.getHACCPTypeOptions(state),
});

HACCPTable = connect(mapStateToProps)(HACCPTable);

class HACCPForm extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };
  render() {
    const { isReadOnly } = this.props;
    return (
      <FieldArray
        name={Fields.HACCP}
        component={HACCPTable}
        isReadOnly={isReadOnly}
      />
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  const HACCPs = values[Fields.HACCP];

  const HACCPErrors = [];

  if (Array.isArray(HACCPs)) {
    HACCPs.forEach((haccp, index) => {
      const HACCPError = {};
      const description = _.get(haccp, HACCPFieldEnum.Description);
      const haccpTypeId = _.get(haccp, HACCPFieldEnum.HACCPTypeId);
      if (!description) {
        HACCPError[HACCPFieldEnum.Description] = 'Description is required.';
      }
      if (!haccpTypeId) {
        HACCPError[HACCPFieldEnum.HACCPTypeId] = 'HACCP Type is required.';
      }
      HACCPErrors[index] = HACCPError;
    });
  }

  errors[Fields.HACCP] = HACCPErrors;
  return errors;
};

HACCPForm = reduxForm({
  form: HACCP_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(HACCPForm);

export { HACCPForm };



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/HACCPForm.js